<template>
  <div class="budget-content">
    <div class="header">
      <div class="content-header">
        <v-btn
          class="add-screen"
          icon
          color="primary"
          @click="create"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <h2>Orçamentos</h2>
      </div>
      <div class="search">
        <v-text-field
          v-model="term"
          v-debounce:1s="handleSearch"
          placeholder="Digite para buscar"
          style="width: calc(100% - 75px); float: left;"
          hide-details
          clearable
          outlined
          dense
          @click:clear="cleared()"
        ></v-text-field>
        <v-badge
          :value="filters.byDate"
          color="error"
          overlap
        >
          <v-btn
            style="width: 65px; padding: 19px; margin-left: 10px;"
            color="primary"
            outlined
            hide-details
            @click="isFilterModalActive = true"
          >
            <v-icon>mdi-filter</v-icon>
          </v-btn>
        </v-badge>
      </div>
      <v-tabs v-model="tab" fixed-tabs background-color="#f8f8f8" color="#48B38B" @change="onTabChange">
        <v-tabs-slider color="#48B38B"></v-tabs-slider>
        <v-tab>
          Pendentes
        </v-tab>
        <v-tab>
          Aprovados
        </v-tab>
        <v-tab>
          Cancelados
        </v-tab>
      </v-tabs>
    </div>
    <div class="budgets-content">
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <ListBudgets :budgets="budgets" @select="openBudgetDialog" @load-more="loadMore" />
        </v-tab-item>
        <v-tab-item>
          <ListBudgets :budgets="budgets" @select="openBudgetDialog" @load-more="loadMore" />
        </v-tab-item>
        <v-tab-item>
          <ListBudgets :budgets="budgets" @select="openBudgetDialog" @load-more="loadMore" />
        </v-tab-item>
      </v-tabs-items>
    </div>

    <BudgetDialog
      v-if="budget_dialog.open"
      :dialog="budget_dialog"
      @close-dialog="closeBudgetDialog"
    />

    <v-dialog v-model="isFilterModalActive" scrollable persistent>
      <v-card>
        <v-card-title class="px-4" style="text-align: center;">
          Filtrar por data
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4 px-3 pt-1">
          <v-date-picker
            v-if="filters.byDate"
            v-model="filters.date"
            class="pb-3"
            locale="pt-br"
            color="#48B38B"
            full-width
            range
          ></v-date-picker>
          <v-btn
            @click="filters.byDate = !filters.byDate"
            :color="filters.byDate ? 'red' : 'primary'"
            outlined
            block
          >
            <v-icon left>{{ filters.byDate ? 'mdi-close' : 'mdi-calendar' }}</v-icon>
            {{ filters.byDate ? 'Desativar filtro por data' : 'Ativar filtro por data' }}
          </v-btn>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text @click="isFilterModalActive = false">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            @click="handleSearch()"
            color="primary"
            depressed
          >
            Pesquisar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BudgetService from '@/services/api/budget';
import BudgetDialog from '@/components/Budget/Dialog';
import ListBudgets from '@/components/Budget/ListBudgets';

export default {
  components: {
    BudgetDialog,
    ListBudgets,
  },
  data () {
    return {
      tab: 0,
      status: 'pendente',
      term: null,
      budgets: [],
      budget_dialog: {
        open: false,
      },
      currentPage: 1,
      itemsPerPage: 15,
      isFilterModalActive: false,
      filters: {
        byDate: false,
        date: [new Date().toISOString().substr(0, 10), new Date().toISOString().substr(0, 10)],
      },
    }
  },
  created() {
    this.search();
  },
  methods: {
    openBudgetDialog(){
      this.budget_dialog = {
        open: true,
      };
    },
    closeBudgetDialog() {
      this.budget_dialog = { open: false };
      this.$store.dispatch('Budget/cleanSelectedBudget');
      this.handleSearch();
    },
    onTabChange() {
      switch (this.tab) {
        case 0:
          this.status = 'pendente';
          break;
        case 1:
          this.status = 'aprovado';
          break;
        case 2:
          this.status = 'cancelado';
          break;
        default:
          this.status = '';
          break;
      }

      this.handleSearch();
    },
    cleared() {
      this.term = null;
      this.handleSearch();
    },
    handleSearch() {
      this.isFilterModalActive = false;
      this.currentPage = 1;
      this.budgets = [];
      this.$store.dispatch('Budget/setHasMoreData', false);
      this.search();
    },
    async search() {
      this.$store.dispatch('Budget/setLoading', true);

      let startDate = null;
      let endDate = null;

      if (this.filters.byDate) {
        [startDate, endDate] = this.filters.date;
      }

      const queryParams = {
        description: this.term,
        status: this.status,
        size: this.itemsPerPage,
        page: this.currentPage,
        startDate,
        endDate,
      };

      try {
        const response = await BudgetService.search(queryParams);
        const responseData = response.data;

        if (responseData && responseData.rows) {
          const newBudgets = responseData.rows.filter(budget => !this.budgets.find(s => s.id === budget.id));
          this.budgets = [...this.budgets, ...newBudgets];
        }

        this.currentPage = responseData.currentPage || 1;
        const totalPages = responseData.totalPages || 1;
        const hasMoreData = this.currentPage < totalPages;

        this.$store.dispatch('Budget/setHasMoreData', hasMoreData);
      } catch (error) {
        console.error(error);
      } finally {
        this.$store.dispatch('Budget/setLoading', false);
      }
    },
    create() {
      BudgetService.create().then((response) => {
        this.$store.commit('Budget/SET_SELECTED_BUDGET', response.data.budget);

        this.$store.commit('Budget/ADD_LOG', {
          description: 'Orçamento criado',
          createdAt: new Date().toISOString(),
          user: this.$store.getters['Auth/user'],
        });

        this.openBudgetDialog();
      }).catch((error) => {
        console.error(error);
      });
    },
    loadMore() {
      this.currentPage += 1;
      this.search();
    },
  },
}
</script>

<style lang="scss">
.budget-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  box-shadow: none !important;
  height: calc(100% - 90px) !important;

  .header {
    width: 100%;
    border-radius: 0px !important;

    .content-header {
      padding: 20px 20px;
      background-color: #EEEEEE;
      color: rgba(0, 0, 0, 0.6) !important;

      .add-screen {
        float: right;
        padding: 10px;
      }
    }

    .search {
      padding: 10px 20px;
      background-color: #f8f8f8;
    }
  }
}

.v-slide-group__prev {
  display: none !important;
}
</style>
